// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import {
    AddedItemModel,
    ChangeRequestModel,
} from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@store/Overrides/Components/SmallHeadingAndText";
import { orderChangeProps, OrderChangeStyles } from "@store/Themes/common/props/orderChange";
import { productLineProps } from "@store/Themes/common/props/productLine";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    order?: OrderModel;
    extendedStyles?: ReviewChangeRequestLinesListStyles;
    showLineNumber?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
    changeRequestOrder: state.greif.pages.orderChange.changeRequestOrder,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReviewOrderChangeRequestLineNotesStyles {
    typographyStyles?: TypographyProps;
    gridItemStyles?: GridItemProps;
    wrapper?: InjectableCss;
}
export interface UpdatedLineStyle {
    wrapper?: InjectableCss;
    oldValue?: TypographyProps;
    newValue?: TypographyProps;
    newValueCanceled?: TypographyProps;
}

export interface ReviewChangeRequestLinesListStyles {
    orderLineCartWrapper?: InjectableCss;
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCardImageGridItem?: GridItemProps;
    orderLineCardInfoGridItem?: GridItemProps;
    orderLineCardInfoGridContainer?: GridContainerProps;
    productBrandStyles?: ProductBrandStyles;
    productInfoPartNumbersGridItem?: GridItemProps;
    productInfoGridItem?: GridItemProps;
    productInfoBrandDescriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    block?: BlockProps;
    productImage?: ProductImageStyles;
    orderLineInfoContainer?: GridContainerProps;
    productPartNumbers?: ProductPartNumbersStyles;
    updatedPrice?: UpdatedLineStyle;
    changeRequestGridContainer?: GridContainerProps;
    addedLineOverlayItem?: GridItemProps;
    addedTag?: InjectableCss;
    changeInfoHeadingAndText?: SmallHeadingAndTextStyles;
    changeRequestReasonGridItem?: GridItemProps;
    changeRequestNotesGridItem?: GridItemProps;
    changeRequestQtyGridItem?: GridItemProps;
}

export const reviewChangeRequestLinesListStyles: ReviewChangeRequestLinesListStyles = {
    block: orderChangeProps.block,
    orderLineCartWrapper: mergeProps<OrderChangeStyles["orderLineCartWrapper"]>(orderChangeProps.orderLineCartWrapper, {
        css: css`
            border-color: ${getColor("success")};
        `,
    }),
    orderLineCardGridContainer: orderChangeProps.orderLineCardGridContainer,
    orderLineCardImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    orderLineCardInfoGridItem: productLineProps.contentGridItem,
    orderLineCardInfoGridContainer: productLineProps.contentContainer,
    productInfoGridItem: productLineProps.infoGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productInfoBrandDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: productLineProps.description,
    productInfoPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    changeRequestGridContainer: orderChangeProps.ocrGridContainer,
    addedLineOverlayItem: orderChangeProps.addedLineOverlayItem,
    addedTag: orderChangeProps.addedTag,
    changeInfoHeadingAndText: orderChangeProps.changeInfoHeadingAndText,
    changeRequestReasonGridItem: orderChangeProps.reasonGridItem,
    changeRequestNotesGridItem: orderChangeProps.notesGridItem,
    changeRequestQtyGridItem: orderChangeProps.qtyGridItem,
};

const ReviewOrderChangeRequestLineAddedProductInfo = ({
    newLine,
    styles,
}: {
    newLine: AddedItemModel;
    styles: ReviewChangeRequestLinesListStyles;
    showLineNumber: boolean;
}) => {
    return (
        <GridItem {...styles.productInfoGridItem}>
            <GridContainer {...styles.orderLineInfoContainer}>
                <GridItem {...styles.productInfoBrandDescriptionGridItem}>
                    {newLine.product.brand && (
                        <ProductBrand brand={newLine.product.brand} extendedStyles={styles.productBrandStyles} />
                    )}
                    <ProductDescription product={newLine} extendedStyles={styles.productDescriptionStyles} />
                </GridItem>
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={newLine.product.productNumber}
                        customerProductNumber={newLine.product.customerProductNumber}
                        manufacturerItem={newLine.product.manufacturerItem}
                        extendedStyles={styles.productPartNumbers}
                    />
                </GridItem>
            </GridContainer>
        </GridItem>
    );
};

const ReviewOrderChangeRequestAddedLineCard = (props: {
    orderLine: AddedItemModel;
    styles: ReviewChangeRequestLinesListStyles;
    showLineNumber: boolean;
    changeRequestOrder: ChangeRequestModel;
}) => {
    const { orderLine, styles, showLineNumber, changeRequestOrder } = props;
    const [currentLine, setCurrentLine] = useState<AddedItemModel>({} as AddedItemModel);

    useEffect(() => {
        if (changeRequestOrder && changeRequestOrder.orderLines) {
            const line = changeRequestOrder?.newLines?.find(l => l.product.id === orderLine.product.id);
            if (line) {
                setCurrentLine(line);
            }
        }
    }, [changeRequestOrder]);

    return (
        <StyledWrapper {...styles.orderLineCartWrapper}>
            <GridContainer
                {...styles.orderLineCardGridContainer}
                data-test-selector={`orderLineCard${orderLine.product.id}`}
            >
                <GridItem {...styles.addedLineOverlayItem}>
                    <StyledWrapper {...styles.addedTag}>
                        <Typography>{translate("Added")}</Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.orderLineCardImageGridItem}>
                    <ProductImage product={orderLine as any} size="medium" extendedStyles={styles.productImage} />
                </GridItem>
                <GridItem {...styles.orderLineCardInfoGridItem}>
                    <GridContainer {...styles.orderLineCardInfoGridContainer}>
                        <ReviewOrderChangeRequestLineAddedProductInfo
                            newLine={orderLine}
                            styles={styles}
                            showLineNumber={showLineNumber}
                        />
                    </GridContainer>
                </GridItem>
            </GridContainer>
            {!orderLine.product.id ? (
                <GridContainer {...styles.changeRequestGridContainer}>
                    <GridItem width={12}>
                        <Typography>{siteMessage("ReviewOrderChange_ProductNoLongerAvailable")}</Typography>
                    </GridItem>
                </GridContainer>
            ) : (
                <GridContainer {...styles.changeRequestGridContainer}>
                    <GridItem {...styles.changeRequestReasonGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("Change Request Reason")}
                            text={currentLine.changeReason || translate("N/A")}
                        />
                    </GridItem>
                    <GridItem {...styles.changeRequestNotesGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("Change Request Note")}
                            text={currentLine.changeNotes || translate("N/A")}
                        />
                    </GridItem>
                    <GridItem {...styles.changeRequestQtyGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("New QTY")}
                            text={currentLine.newQuantity}
                        />
                    </GridItem>
                </GridContainer>
            )}
        </StyledWrapper>
    );
};

const ReviewOrderChangeRequestAddedLine = ({ order, extendedStyles, showLineNumber, changeRequestOrder }: Props) => {
    const styles = useMergeProps(reviewChangeRequestLinesListStyles, extendedStyles);
    const [canTrackViewItemList, setCanTrackViewItemList] = useState(true);
    const trackViewItemList = ga.use.trackViewItemList({}, { order });

    if (!order || !order.orderLines) {
        return null;
    }

    if (canTrackViewItemList) {
        trackViewItemList();
        setCanTrackViewItemList(false);
    }

    return (
        <Block {...styles.block}>
            {changeRequestOrder?.newLines?.map(newProduct => (
                <ReviewOrderChangeRequestAddedLineCard
                    orderLine={newProduct}
                    styles={styles}
                    key={newProduct.product.id + 1}
                    showLineNumber={showLineNumber!}
                    changeRequestOrder={changeRequestOrder}
                />
            ))}
        </Block>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewOrderChangeRequestAddedLine);
